module.exports = __webpack_public_path__ + "static/media/teen_awareness-mb-en.1749bb96.jpg";